import { Button } from "react-admin";
import { useNavigate } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import { CURRICULUMS, StudentServicePath, TOPICS } from "utils/constants";

const CreateTopicButton = ({ canCreate, id, excludeIds }) => {
  const navigate = useNavigate();
  if (!canCreate) return null;

  return (
    <Button
      variant="text"
      label="Създай"
      startIcon={<AddIcon />}
      onClick={() =>
        navigate(`/${StudentServicePath}${TOPICS}/${CURRICULUMS}/${id}/create`, {
          state: { excludeIds: excludeIds },
        })
      }
      sx={{ mb: 1 }}
    />
  );
};

export default CreateTopicButton;
